import { firebaseClient } from '@/api/axios';
import AppToastContainer from '@/components/app-toast/toast-container';
import ATCMap from '@/components/atc/map';
import ATCHeader from '@/components/layout/atc-header';
import ATCSideBar from '@/components/layout/atc-sidebar';
import SuspenseOutlet from '@/components/suspense-outlet';
import {allAirlinesWhitelistRef, allRadarRef} from '@/firebase/radar';
import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import useUpdateByTime from '@/hooks/useUpdateByTime';
import {setRadars} from '@/redux/slice/emissionSlice';
import {setLayer} from '@/redux/slice/mapSlice';
import store from '@/redux/store';
import {IRadar, IRadarFirebase} from '@/types/radar';
import {getAirportCode} from '@/utils/string';
import {get} from 'firebase/database';
import {useEffect} from 'react';

type AirlineWhitelist = {
  IATA: string;
  ICAO: string;
  aircraft_prefix: string;
  country: string;
  domain: string;
  homebase: string[];
  hometimezone: string;
};

let airlinesWhitelist: Record<string, AirlineWhitelist> | null = null;
export default function ATCLayout(): JSX.Element {
  const dispatch = useAppDispatch();
  const updateRadar = useUpdateByTime({time: 2 * 60 * 1000});
  const token = useAppSelector((state) => state.user.token);

  useEffect(() => {
    const getData = async () => {
      const res = await firebaseClient.get(
        `/sector_info.json?shallow=true`
      );
      window.sectorData = Object.keys(res);
    };
    if (!token) return;
    void getData();
  }, [token]);

  const getData = async () => {
    if (!airlinesWhitelist) {
      const snapshot = await get(allAirlinesWhitelistRef());
      airlinesWhitelist = snapshot.val();
    }
    const airlineKeys = Object.keys(airlinesWhitelist ?? {});
    window.atcTrack = {};
    await get(allRadarRef()).then((snapshot) => {
      const data: IRadarFirebase[] = snapshot.val();
      const temp: IRadar[] = data.map((item) => {
        const depAirportIata = getAirportCode(item.dep_airport);
        const arrAirportIata = getAirportCode(item.arr_airport);
        // if callsign is startWith IATA or ICAO, then set airline is the key of airlinesWhitelist
        let airline = '';
        if (airlinesWhitelist) {
          for (const key of airlineKeys) {
            const icao = airlinesWhitelist[key].ICAO;
            const iata = airlinesWhitelist[key].IATA;
            if (
              item.callsign.startsWith(icao) ||
              item.callsign.startsWith(iata)
            ) {
              airline = key;
              break;
            }
          }
        }
        window.atcTrack[item.callsign] = item?.track ?? '';
        return {
          ...item,
          track: '',
          airline,
          depAirportIata,
          arrAirportIata,
          aircraftType: item.aircraft_type,
          arrAirport: item.arr_airport,
          baroAltitude: item.baro_altitude,
          depAirport: item.dep_airport,
          searchString:
            `${item.callsign}${depAirportIata}${arrAirportIata}`.toLowerCase(),
          trueTrack: item.true_track
        };
      });
      dispatch(setRadars(temp));
    });
  };

  useEffect(() => {
    void getData();
  }, [updateRadar]);

  useEffect(() => {
    window.popupProjectedCII = {};
    if (!store.getState().map.layer.fir) {
      dispatch(setLayer({fir: true}));
      setTimeout(() => {
        window.updateData({
          event: 'toggleFir',
          data: 'visible'
        });
      }, 2000);
    }
  }, []);

  return (
    <div className="w-full max-h-screen overflow-hidden">
      <div className="bg-primary-dark">
        <ATCHeader />
        <div className="flex relative">
          <ATCSideBar />
          <div className="rounded-tl-[8px] overflow-hidden w-full h-full ml-[56px]">
            <ATCMap />
            <SuspenseOutlet />
          </div>
        </div>
      </div>
      <AppToastContainer />
    </div>
  );
}
